/**
 * Account › Connected Tools (MCP) — now just a POINTER. The full manager moved
 * to the Maximus console (`/agent/maximus/mcp`, `MaximusMcpPage`) + the Tools
 * panel; MCP is a tools concern, not an account setting. Self-gated to the MCP
 * surface's audience (beta + admin) so a normal user sees nothing.
 */
import { Link } from 'react-router-dom';
import type { AuthUser } from '../../auth/AuthContext.ts';
import { canUseMcpSettings, MCP_AGENT_SLUG } from '../../agents/mcpApi.ts';

interface Props {
  readonly user: AuthUser | null;
  readonly hidden?: boolean;
}

export default function AccountMcpSection({ user, hidden = false }: Props) {
  if (!canUseMcpSettings(user)) {
    return null;
  }
  return (
    <section className="om-account__section" id="mcp" hidden={hidden}>
      <h2 className="om-account__h2">Connected Tools (MCP)</h2>
      <p className="om-account__hint">
        Connect your own MCP (Model Context Protocol) servers for Maximus to use on your behalf.
        Manage them in the Maximus console.
      </p>
      <Link to={`/agent/${MCP_AGENT_SLUG}/mcp`} className="om-account__action">
        Manage in the Maximus console →
      </Link>
    </section>
  );
}
